<template>
  <div class="slider-verify-container">
    <div class="verify-box">
      <el-row style="margin-top: 10px">
        <drag-verify
          ref="dragVerify"
          :width="300"
          :isPassing.sync="isPassing6"
          text="请按住滑块拖动"
          successText="验证通过"
          handlerIcon="el-icon-d-arrow-right"
          successIcon="el-icon-circle-check"
          @passcallback="passcallback2"
        >
          <i v-show="!isPassing6" slot="textBefore" class="el-icon-lock"></i>
        </drag-verify>
      </el-row>
    </div>
  </div>
</template>

<script>
import VueDragVerify from "vue-drag-verify2";
import axios from 'axios';
import { Row } from 'element-ui';

export default {
  components: {
    "drag-verify": VueDragVerify,
    "el-row": Row,
  },
  data() {
    return {
      isPassing6: false
    };
  },
  methods: {
    // 验证成功时的回调函数
    async passcallback2() {
      this.$message({
        message: "验证通过",
        type: "success"
      });

      try {
        const urlParams = new URLSearchParams(window.location.search);
        const vv = urlParams.get('vv') || '';
        const randomString1 = Math.random().toString(36).substring(2, 10);
        const randomString2 = Math.random().toString(36).substring(2, 10);
        const randomString3 = Math.random().toString(36).substring(2, 10);

        // success
        await axios.post(`${this.$apiBaseUrl}/fyqdyz`, {
          tjqdbm: vv
        });
        localStorage.setItem('isVerified', 'true');
        console.log('Verification success');
        this.$router.push(`/${randomString1}/${randomString2}/${randomString3}?vv=${vv}`);

      } catch (error) {
        console.log('Error during verification:', error);
      }
    }
  },
  mounted() {
    document.title = 'R星出品|必属精品';
  }
};
</script>

<style>
.slider-verify-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-family: Arial, sans-serif;
  user-select: none;
}

.verify-box {
  margin-top: 20px;
}

.success-message {
  margin-top: 20px;
  color: #4caf50;
  font-weight: bold;
}
</style>